import bokmal from './nb-NO'

const messages = {
  'nb-NO': bokmal
}

/* Collect all languages for export */

export default messages
